import {ChangeDetectorRef, Component, Input, numberAttribute, OnInit} from '@angular/core';
import { ClrTabsModule } from "@clr/angular";
import { ClarityIcons, exclamationCircleIcon, exclamationTriangleIcon } from "@cds/core/icon";
import { TranslocoDirective } from "@jsverse/transloco";
import { CommentListComponent } from "../comment-list/comment-list.component";

import { environment as env } from "../../../../environments/environment";
import { NgIf } from "@angular/common";

/**
 * Tab indices for the comment feature card
 * Using numeric indices instead of translated strings to avoid issues with language switching
 */
export enum CommentTabIndex {
  URGENT = 0,
  DONE = 1,
  DELETE = 2
}

/**
 * Component for displaying comments in a tabbed card layout
 *
 * This component uses numeric indices for tab control instead of translated strings
 * to avoid issues with language switching. When using translated strings, the tab
 * selection would break after switching languages because the translated strings
 * would change but the stored activeTab value would still be the old translated string.
 *
 * The component uses ChangeDetectorRef to force change detection when the activeTab
 * property is set, even when it's set to the same value it already has. This ensures
 * that the tab content is properly displayed and reloaded.
 */
@Component({
  selector: 'app-comment-feature-card',
  standalone: true,
  imports: [
    ClrTabsModule,
    TranslocoDirective,
    CommentListComponent,
    NgIf
  ],
  templateUrl: './comment-feature-card.component.html',
  styleUrl: './comment-feature-card.component.sass'
})
export class CommentFeatureCardComponent implements OnInit {
  loading: boolean = true;
  devMode: boolean = false;
  // Using numeric indices instead of translated strings to avoid issues with language switching
  _activeTab: number = CommentTabIndex.URGENT;

  get activeTab(): number {
    return this._activeTab;
  }

  set activeTab(value: number) {
    console.log('CommentFeatureCardComponent: Setting activeTab from', this._activeTab, 'to', value);
    this._activeTab = value;
    // Force change detection to ensure tab content is displayed
    this.cdr.detectChanges();
  }

  @Input() projectId: string = 'null';
  @Input({transform: numberAttribute}) companyId: number = 0;
  @Input() commentType: number = 0;
  @Input({transform: numberAttribute}) staffId: number = 0;
  @Input() subId: number = 0;

  constructor(private cdr: ChangeDetectorRef) {
    this.devMode = env.stages.dev;
    ClarityIcons.addIcons(exclamationCircleIcon, exclamationTriangleIcon);
  }

  ngOnInit() {
    console.log('CommentFeatureCardComponent: ngOnInit called, activeTab =', this.activeTab);
  }
}
